import React from 'react'

import styles from "./styles/ContentContainer.module.scss";

const ContentContainer = ({
    classes = "",
    style = {},
    bg = '',
    hasBoxShadow = false,
    hasBorder = true,
    children
}) => {
    return (
        <div
            className={`${styles.ContentContainer} ${classes}`}
            style={{
                ...style,
                ...(bg ? { backgroundColor: bg } : {}),
                ...(!hasBoxShadow ? { boxShadow: "none" } : {}),
                ...(hasBorder ? { border: "1px solid #7A86D3" } : {})
            }}
        >
            {children}
        </div >
    )
}

export default ContentContainer